import { CustomIconButton, CustomTextField } from "@/src/lib/ui";
import Iconify from "@/src/components/iconify";
import IconCode from "@/src/lib/iconCode";
import { updateDiscountAmount } from "@/src/lib/store/pet-ct-appointment-new/slice";
import { useDispatch, useSelector } from "react-redux";
import { useToast } from "@/src/lib/hooks/useToast";
import { useHODMutation } from "@/src/lib/hooks/useHODMutation";
import { cartApiService } from "@/src/lib/api-services/cartApiServices";
import { useState } from "react";

const PaymentBlock = ({
    discountAmount,
    setAdvancePayment,
    advancePayment,
}) => {
    const testRate = useSelector((state) =>
        Number(state.appointmentNew?.centreDetails?.rate || 0)
    );
    const advancePaymentRequired = useSelector((state) =>
        Number(state.appointmentNew?.centreDetails?.advRequired || 0)
    );

    const checkoutId = useSelector(
        (state) => state?.appointmentNew?.checkoutId
    );
    const dispatch = useDispatch();
    const { showCustomToast } = useToast();

    const { mutate: removeCouponMutate, isLoading: isRemovingCoupon } =
        useHODMutation((data) => cartApiService.removePetCtCoupon(data), {
            onSuccess: (data) => {
                dispatch(updateDiscountAmount(0));
                showCustomToast("Coupon removed successfully", "success");
            },
            onError: (error) => {
                showCustomToast(
                    error?.response?.data?.message ||
                        error?.message ||
                        "Coupon removal failed",
                    "error"
                );
            },
        });
    const removeCouponHandler = () => {
        removeCouponMutate({
            checkoutId: checkoutId,
        });
    };

    const onAdvancePaymentChange = (e) => {
        if (
            Number(e.target.value) + Number(discountAmount) >
            Number(testRate)
        ) {
            showCustomToast(
                "Advance Payment cannot be greater than Total cost of the test",
                "error"
            );
            setAdvancePayment(advancePaymentRequired);
            return;
        }
        setAdvancePayment(e.target.value);
    };

    return (
        <div className="border border-gray-200 mb-4 p-3">
            <p className="md:text-lg text-base font-semibold mb-2">
                Order Summary
            </p>

            <div className="flex flex-row justify-between items-center md:py-2 py-1.5">
                <div className="text-gray-600 text-sm">
                    {" "}
                    Total cost of the test
                </div>
                <div className="flex flex-row items-center">
                    <Iconify icon={IconCode.rupeeBold} width={16} />
                    <div className="font-bold md:text-lg text-base">
                        {testRate}
                    </div>
                </div>
            </div>

            {discountAmount > 0 && (
                <div className="flex flex-row justify-between items-center md:py-2 py-1.5">
                    <div className="text-gray-600 text-sm">Discount</div>
                    <div className="flex flex-row items-center">
                        <div className="flex flex-row items-center">
                            <Iconify icon={IconCode.rupeeBold} width={16} />
                            <div className="font-bold md:text-lg text-base">
                                {discountAmount}
                            </div>
                        </div>
                        <CustomIconButton
                            onClick={removeCouponHandler}
                            size="small"
                            color="default"
                            disabled={isRemovingCoupon}
                            className="cursor-pointer "
                        >
                            <Iconify
                                className="text-primary"
                                icon={
                                    isRemovingCoupon
                                        ? IconCode.loadingTwoTone
                                        : IconCode.delete
                                }
                                width={18}
                            />
                        </CustomIconButton>
                    </div>
                </div>
            )}

            <div className="flex flex-row justify-between items-center md:py-2 py-1.5 relative">
                <div className="text-black text-base captialize font-bold">
                    Advance Payment
                </div>
                <div className="flex flex-row items-center">
                    <div className="w-28">
                        <CustomTextField
                            startIcon={
                                <Iconify icon={IconCode.rupeeBold} width={16} />
                            }
                            inputClassName="font-bold !text-lg !text-center leading-none "
                            fullWidth
                            size="small"
                            type="number"
                            value={advancePayment}
                            onChange={onAdvancePaymentChange}
                        />
                    </div>
                    {/* <div className="font-bold md:text-lg text-base">
                        {AdvancePayment}
                    </div> */}
                </div>
                <div className=" text-xs captialize text-right absolute right-0 -bottom-2.5 flex flex-row items-center">
                    <div className="text-xs text-green-700  ">
                        Minimum Required :
                    </div>
                    <div className="text-green-700">
                        <Iconify icon={IconCode.rupeeBold} width={12} />
                    </div>
                    <div className="font-bold text-xs text-green-700">
                        {advancePaymentRequired}
                    </div>
                </div>
            </div>

            <div className="flex flex-row justify-between items-center py-2">
                <div>Balance due before test</div>
                <div className="flex flex-row items-center">
                    <Iconify icon={IconCode.rupeeBold} width={16} />
                    <div className="font-bold md:text-lg text-base">
                        {testRate -
                            ((Number(discountAmount) || 0) +
                                Number(advancePayment)) || 0}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentBlock;
